/**
 * Utility functions for handling paths in different environments
 */

/**
 * Returns the base path prefix based on the current environment
 * @returns {string} The base path prefix to use for assets
 */
export const getBasePath = () => {
  return window.location.hostname === 'immuta.art' ? '/hash-gallery' : '';
};

/**
 * Resolves a path to account for the deployment environment
 * @param {string} path - The path to resolve
 * @returns {string} The resolved path with appropriate prefix
 */
export const resolvePath = (path) => {
  const basePath = getBasePath();
  
  // If path already starts with basePath or is an absolute URL, return as is
  if (path.startsWith('http') || (basePath && path.startsWith(basePath))) {
    return path;
  }
  
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  
  return `${basePath}/${cleanPath}`;
};
